var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('input-row', {
    attrs: {
      "label": "이름",
      "pointer": ""
    }
  }, [_c('input-item', {
    on: {
      "input": _vm.sync
    },
    model: {
      value: _vm.applicant.name,
      callback: function callback($$v) {
        _vm.$set(_vm.applicant, "name", $$v);
      },
      expression: "applicant.name"
    }
  })], 1), _c('input-row', {
    attrs: {
      "label": "학교/학과",
      "pointer": ""
    }
  }, [_c('div', {
    staticClass: "row row--small"
  }, [_c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('input-item', {
    on: {
      "input": _vm.sync
    },
    model: {
      value: _vm.applicant.affiliation,
      callback: function callback($$v) {
        _vm.$set(_vm.applicant, "affiliation", $$v);
      },
      expression: "applicant.affiliation"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('input-item', {
    on: {
      "input": _vm.sync
    },
    model: {
      value: _vm.applicant.department,
      callback: function callback($$v) {
        _vm.$set(_vm.applicant, "department", $$v);
      },
      expression: "applicant.department"
    }
  })], 1)])]), _c('input-row', {
    attrs: {
      "label": "생년월일",
      "pointer": ""
    }
  }, [_c('div', {
    staticClass: "form-birth"
  }, [_c('input-birth', {
    attrs: {
      "mode": "년"
    },
    on: {
      "input": _vm.sync
    },
    model: {
      value: _vm.applicant.bornY,
      callback: function callback($$v) {
        _vm.$set(_vm.applicant, "bornY", $$v);
      },
      expression: "applicant.bornY"
    }
  }), _c('input-birth', {
    attrs: {
      "mode": "월"
    },
    on: {
      "input": _vm.sync
    },
    model: {
      value: _vm.applicant.bornM,
      callback: function callback($$v) {
        _vm.$set(_vm.applicant, "bornM", $$v);
      },
      expression: "applicant.bornM"
    }
  }), _c('input-birth', {
    attrs: {
      "mode": "일",
      "year": _vm.applicant.bornY,
      "month": _vm.applicant.bornM
    },
    on: {
      "input": _vm.sync
    },
    model: {
      value: _vm.applicant.bornD,
      callback: function callback($$v) {
        _vm.$set(_vm.applicant, "bornD", $$v);
      },
      expression: "applicant.bornD"
    }
  })], 1)]), _c('input-row', {
    attrs: {
      "label": "연락처",
      "pointer": ""
    }
  }, [_c('div', {
    staticClass: "form-tel"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.applicant.phone1,
      expression: "applicant.phone1"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "name": "phone1",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.applicant.phone1
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.applicant, "phone1", $event.target.value);
      }, _vm.sync]
    }
  }), _c('span', {
    staticClass: "text"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.applicant.phone2,
      expression: "applicant.phone2"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "name": "phone2",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.applicant.phone2
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.applicant, "phone2", $event.target.value);
      }, _vm.sync]
    }
  }), _c('span', {
    staticClass: "text"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.applicant.phone3,
      expression: "applicant.phone3"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "name": "phone3",
      "maxlength": "4"
    },
    domProps: {
      "value": _vm.applicant.phone3
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.applicant, "phone3", $event.target.value);
      }, _vm.sync]
    }
  })])]), _c('input-row', {
    attrs: {
      "label": "이메일",
      "pointer": ""
    }
  }, [_c('input-email', {
    on: {
      "input": _vm.sync
    },
    model: {
      value: _vm.applicant,
      callback: function callback($$v) {
        _vm.applicant = $$v;
      },
      expression: "applicant"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }